import React from 'react';
import { SurveyMainType } from '../../types/SurveyMainType';
import { SurveyQuestionType } from '../../types/SurveyQuestionType';
import { SurveyLabel } from './SurveyLabel';
import { SurveyString } from './SurveyString';
import { SurveyMultiSelect } from './SurveyMultiSelect';
import { SurveySelect } from './SurveySelect';

interface IGenerateQuestionProps {
    question: SurveyQuestionType;
    pppData?: React.Dispatch<React.SetStateAction<SurveyMainType | undefined>>;
    errorIds?: number[];
};

const GenerateQuestion = ({ 
    question, 
    pppData,
    errorIds
} : IGenerateQuestionProps) => {
    if(pppData == null) return null;
    switch(question.type) {
        case 1:
            return <SurveyLabel 
                        question={question} 
                        pppData={pppData} 
                        errorIds={errorIds}
                    />
        case 2:
            return <SurveyString 
                        question={question} 
                        pppData={pppData} 
                        errorIds={errorIds}
                    />
        case 8:
            return <SurveySelect 
                        question={question} 
                        pppData={pppData}
                        errorIds={errorIds} 
                    />
        case 9:
            return <SurveyMultiSelect 
                        question={question} 
                        pppData={pppData}
                        errorIds={errorIds}
                    />
        default:
            return null;
    }
};

export {
    GenerateQuestion
}